import React, { useEffect } from 'react';

import { captureError } from '../../utilities/error';
import { useRedirect } from '../../hooks/useRedirect';
import Loading from '../../components/loading/Loading';
import useUrlParam from '../../mp/hooks/useUrlParam';
import { useOpenBookmarkQuery } from '../../redux/rtk';

const OpenBookmarkPage = () => {
  const redirect = useRedirect();
  const shareToken = useUrlParam('shareToken');

  const openBookmarkState = useOpenBookmarkQuery(
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    { shareToken: shareToken!, redirectToRequestAccess: true },
    { skip: !shareToken }
  );

  useEffect(() => {
    const error = openBookmarkState.error;
    if (error) captureError(error);
  }, [openBookmarkState.error]);

  useEffect(() => {
    const data = openBookmarkState.data;
    if (data && data.redirectUrl) {
      redirect.push(data.redirectUrl);
    }
  }, [openBookmarkState.data, redirect]);

  return <Loading />;
};

export default OpenBookmarkPage;
